export default __webpack_public_path__ + "alberta-setting.7f655f432252a7d81d63.svg";